<template>
  <v-form ref="form" v-model="isValid">
    <v-dialog v-model="dialog" persistent max-width="512">
      <v-card id="user-layers__card">
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
        <v-card-text style="min-height: 300px">
          <v-row no-gutters>
            <v-col xs="12" class="py-0 pr-2" cols="6">
              <v-text-field
                outlined
                v-model="computedGroup.name_pl"
                :label="$i18n.t('settings.polishGroupName')"
                :rules="requiredRules"
              />
            </v-col>
            <v-col xs="12" class="py-0 pl-2" cols="6">
              <v-text-field
                outlined
                v-model="computedGroup.name_en"
                :label="$i18n.t('settings.englishGroupName')"
                :rules="requiredRules"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col xs="12" class="py-0 pr-2" cols="6">
              <v-select
                v-model="computedGroup.layers"
                :label="$i18n.t('settings.wmsLayers')"
                :items="notAssignedWmsLayers.concat(assignedWmsLayers)"
                :item-text="`name_${$i18n.locale}`"
                item-value="id"
                :menu-props="{ offsetY: true }"
                :no-data-text="$i18n.t('settings.noNotAssignedWmsLayers')"
                multiple
                outlined
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn color="primary" text @click="cancel">{{ cancelTitle }}</v-btn>
          <v-btn color="primary" text @click="success" :disabled="!isValid">
            {{ successTitle }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
export default {
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    group: {
      required: true,
      type: Object
    },
    notAssignedWmsLayers: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: () => ({
    assignedWmsLayers: [],
    isValid: false
  }),
  computed: {
    cancelTitle() {
      return this.$i18n.t('default.cancel');
    },
    computedGroup: {
      get() {
        return this.group;
      },
      set(nV) {
        this.$emit('update:group', nV);
      }
    },
    dialogTitle() {
      return this.isNew ? this.$i18n.t('settings.addWmsGroup') : this.$i18n.t('settings.editWmsGroup');
    },
    isNew() {
      return !(this.computedGroup.id || this.computedGroup.id == '0');
    },
    requiredRules() {
      return [
        value => !!value || this.$i18n.t('default.requiredField'),
        value => (value && value.length > 0) || this.$i18n.t('default.requiredField')
      ];
    },
    successTitle() {
      return this.isNew ? this.$i18n.t('default.add') : this.$i18n.t('default.edit');
    },
    wmsLayers() {
      return this.$store.getters.getWMSLayers;
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    success() {
      this.$emit('success');
    }
  },
  watch: {
    dialog(nV) {
      if (nV) {
        this.$refs.form.resetValidation();
        this.assignedWmsLayers =
          this.computedGroup && this.computedGroup.layers
            ? this.computedGroup.layers.map(layer => this.wmsLayers.find(wmsLayer => layer === wmsLayer.id))
            : [];
      }
    }
  }
};
</script>